import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import EmbeddableEditor from './pages/HtmlEditorTestPage/components/EmbeddableEditor/EmbeddableEditor';
import TestPage from './pages/HtmlEditorTestPage/TestPage';
import HomePage from './pages/HomePage/HomePage';
import DataSourcesPage from './pages/DataSourcesPage/DataSourcesPage';
import ApplicationsPage from './pages/ApplicationsPage/ApplicationsPage';
import CallbackPage from './pages/CallbackPage/CallbackPage';
import { FederateProvider } from './shared/contexts/FederateContext';
import { RegionProvider } from './shared/contexts/RegionContext';
import './global.scss';

function FederateRoutesLayout() {
  return (
    <FederateProvider>
      <Outlet />
    </FederateProvider>
  );
}

function App() {
  return (
    <RegionProvider>
      <Router>
        <Routes>
          {/* OIDC callback — must NOT be wrapped by FederateProvider, since the cookie is being set here */}
          <Route path="/callback" element={<CallbackPage />} />
          {/* Routes that require federate authentication */}
          <Route element={<FederateRoutesLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/collections" element={<DataSourcesPage />} />
            <Route path="/applications" element={<ApplicationsPage />} />
            <Route path="/html-editor" element={<EmbeddableEditor />} />
            <Route path="/html-editor/test" element={<TestPage />} />
            <Route path="/artifacts/:artifactId" element={<EmbeddableEditor />} />
          </Route>
        </Routes>
      </Router>
    </RegionProvider>
  );
}

export default App;
